import React from 'react';
import MessageItem from './MessageItem'; // Import the MessageItem component

/**
 * Renders the list of chat messages.
 * 
 * @param {object} props - Component props.
 * @param {Array} props.messages - Array of message objects to display.
 * @param {React.RefObject} props.endOfMessagesRef - Ref to attach to the end of the list for scrolling.
 * @param {boolean} props.isProcessing - Whether the AI is currently processing a response.
 */
export default function ChatMessages({ messages, endOfMessagesRef, isProcessing }) {
    return (
        <div className="flex-1 overflow-y-auto p-4 flex flex-col" data-testid="messages-container">
            {/* Messages container that grows to fill available space */}
            <div className="flex-1 space-y-4">
                {messages
                    // Filter out messages marked as hidden or those without any text content
                    .filter(msg => !msg.isHidden && msg.text && msg.text.trim()) 
                    .map((msg, index) => (
                        // Use message id if available and unique, otherwise fallback to index
                        // Ensure a unique key for each message item
                        <MessageItem key={msg.id || `msg-${index}`} message={msg} /> 
                    ))}
            </div>
            
            {/* Typing indicator that sticks to the bottom */}
            {isProcessing && (
                <div className="flex items-start space-x-2 mt-4">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-semibold">
                        AI
                    </div>
                    <div className="flex-1 bg-gray-100 rounded-lg p-3">
                        <div className="flex space-x-1">
                            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Empty div at the end to target for scrolling */}
            <div ref={endOfMessagesRef} /> 
        </div>
    );
}